export const QuestionProgress = ({ current, total }) => {
  const percent = Math.round((current / total) * 100);

  return (
    <div className="supplement-question-progress" data-testid="supplement-question-progress">
      <span data-testid="supplement-question-progress-label">Question {current} of {total}</span>
      <div
        className="supplement-question-progress__track"
        role="progressbar"
        aria-label="Supplement Check progress"
        aria-valuemin="1"
        aria-valuemax={total}
        aria-valuenow={current}
        data-testid="supplement-question-progress-bar"
      >
        <span style={{ width: `${percent}%` }} data-testid="supplement-question-progress-fill" />
      </div>
    </div>
  );
};